module.exports = __webpack_public_path__ + "img/icon_telegram.7f17674e.png";